var $54b47fc030b7b21e$exports = {};
/* =========================================================
   CONSTANTES & SEUILS
========================================================= */ const $54b47fc030b7b21e$var$TRANSPARENCY_THRESHOLD = 0.1;
/* =========================================================
   SÉLECTEURS DOM — ÉCRANS & NAVIGATION
========================================================= */ const $54b47fc030b7b21e$var$firstScreen = document.getElementById("first-screen");
const $54b47fc030b7b21e$var$startScreen = document.getElementById("start-screen");
const $54b47fc030b7b21e$var$gameOverScreen = document.getElementById("game-over");
const $54b47fc030b7b21e$var$gameOverMessage = document.getElementById("game-over-message");
const $54b47fc030b7b21e$var$pauseMenu = document.getElementById("pause-menu");
const $54b47fc030b7b21e$var$menuButton = document.getElementById("menu-button");
/* =========================================================
   SÉLECTEURS DOM — CAROUSEL NORMAL
========================================================= */ const $54b47fc030b7b21e$var$track = document.querySelector(".carousel-track");
const $54b47fc030b7b21e$var$rooms = document.querySelectorAll(".img-text");
const $54b47fc030b7b21e$var$btnLeft = document.querySelector(".arrow-left");
const $54b47fc030b7b21e$var$btnRight = document.querySelector(".arrow-right");
const $54b47fc030b7b21e$var$carousel = document.getElementById("carousel");
/* =========================================================
   SÉLECTEURS DOM — CAROUSEL HARD
========================================================= */ const $54b47fc030b7b21e$var$carouselHard = document.getElementById("carousel-hard");
const $54b47fc030b7b21e$var$trackHard = document.querySelector(".carousel-track-hard");
const $54b47fc030b7b21e$var$roomsHard = document.querySelectorAll(".img-text-hard");
const $54b47fc030b7b21e$var$btnLeftHard = document.querySelector(".arrow-left-hard");
const $54b47fc030b7b21e$var$btnRightHard = document.querySelector(".arrow-right-hard");
const $54b47fc030b7b21e$var$timerElementHard = document.getElementById("timer-hard");
/* =========================================================
   SÉLECTEURS DOM — TIMER & BOUTONS
========================================================= */ const $54b47fc030b7b21e$var$timerElement = document.getElementById("timer");
const $54b47fc030b7b21e$var$difficultyButtons = document.querySelectorAll(".difficulty-button");
const $54b47fc030b7b21e$var$restartButton = document.getElementById("restart-button");
const $54b47fc030b7b21e$var$backButton = document.getElementById("back-button");
const $54b47fc030b7b21e$var$resumeButton = document.getElementById("resume-button");
const $54b47fc030b7b21e$var$quitButton = document.getElementById("quit-button");
/* =========================================================
   SÉLECTEURS DOM — SETTINGS
========================================================= */ const $54b47fc030b7b21e$var$pauseTitle = document.getElementById("pause-title");
const $54b47fc030b7b21e$var$pauseMainButtons = document.getElementById("pause-main-buttons");
const $54b47fc030b7b21e$var$settingsMain = document.getElementById("settings-main");
const $54b47fc030b7b21e$var$panelGraphics = document.getElementById("panel-graphics");
const $54b47fc030b7b21e$var$panelSound = document.getElementById("panel-sound");
const $54b47fc030b7b21e$var$panelControls = document.getElementById("panel-controls");
/* =========================================================
   VARIABLES GLOBALES — JEU
========================================================= */ let $54b47fc030b7b21e$var$index = 0;
let $54b47fc030b7b21e$var$indexHard = 0;
let $54b47fc030b7b21e$var$timeLeft = 120;
let $54b47fc030b7b21e$var$monsterCount = 0;
let $54b47fc030b7b21e$var$timerInterval = null;
let $54b47fc030b7b21e$var$monsterInterval = null;
let $54b47fc030b7b21e$var$glitchInterval = null;
let $54b47fc030b7b21e$var$timestampInterval = null;
let $54b47fc030b7b21e$var$doorInterval = null;
let $54b47fc030b7b21e$var$objectInterval = null;
let $54b47fc030b7b21e$var$timeAlertPlayed = false;
let $54b47fc030b7b21e$var$alarmPlayed = false;
/* =========================================================
   VARIABLES GLOBALES — MONSTRES
========================================================= */ let $54b47fc030b7b21e$var$monsterQueue = [];
let $54b47fc030b7b21e$var$lastSpawnedMonster = null;
let $54b47fc030b7b21e$var$monsterQueueHard = [];
let $54b47fc030b7b21e$var$lastSpawnedMonsterHard = null;
const $54b47fc030b7b21e$var$monsterRegistry = [];
/* =========================================================
   VARIABLES GLOBALES — OBJETS (MODE HARD)
========================================================= */ let $54b47fc030b7b21e$var$objectCount = 0;
let $54b47fc030b7b21e$var$objectQueue = [];
let $54b47fc030b7b21e$var$lastSpawnedObject = null;
let $54b47fc030b7b21e$var$totalObjects = 10;
let $54b47fc030b7b21e$var$missedObjects = 0;
/* =========================================================
   VARIABLES GLOBALES — SETTINGS & AUDIO
========================================================= */ let $54b47fc030b7b21e$var$masterVolume = 0.5;
let $54b47fc030b7b21e$var$musicVolume = 0.5;
let $54b47fc030b7b21e$var$clickVolume = 0.5;
let $54b47fc030b7b21e$var$sensitivity = 5;
let $54b47fc030b7b21e$var$settingsFromFirst = false;
let $54b47fc030b7b21e$var$firstMusicStarted = false;
/* =========================================================
   VOLUME — BASE & HELPERS
========================================================= */ const $54b47fc030b7b21e$var$BASE_VOLUMES = {
    "ambiance-music": 1.0,
    "first-screen-music": 0.9,
    "win-sound": 1.0,
    "alarm-sound": 0.3,
    "dead-sound": 1.0,
    "iiii-sound": 0.6,
    "time-sound": 1.0,
    "monster-glitch-sound": 0.9,
    "r-door-sound": 1.0,
    "l-door-sound": 1.0,
    "hover-sound": 0.8,
    "clicking-sound": 0.8,
    "camera-sound": 0.7,
    "missed-sound": 0.6,
    "loading-sound": 0.4
};
function $54b47fc030b7b21e$var$getVolume(id) {
    const base = $54b47fc030b7b21e$var$BASE_VOLUMES[id] ?? 0.5;
    const el = document.getElementById(id);
    if (!el) return 0;
    const isMusicClass = el.classList.contains("sound-music");
    const isClickClass = el.classList.contains("sound-click");
    if (isMusicClass) return Math.min(1, $54b47fc030b7b21e$var$masterVolume * $54b47fc030b7b21e$var$musicVolume * base);
    if (isClickClass) return Math.min(1, $54b47fc030b7b21e$var$masterVolume * $54b47fc030b7b21e$var$clickVolume * base);
    return Math.min(1, $54b47fc030b7b21e$var$masterVolume * base);
}
function $54b47fc030b7b21e$var$applyVolumes() {
    Object.keys($54b47fc030b7b21e$var$BASE_VOLUMES).forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.volume = $54b47fc030b7b21e$var$getVolume(id);
    });
}
/* =========================================================
   AUDIO — STOP HELPERS
========================================================= */ function $54b47fc030b7b21e$var$stopAllSounds() {
    document.querySelectorAll("audio:not(#first-screen-music):not(#alarm-sound)").forEach((el)=>{
        el.pause();
        el.currentTime = 0;
    });
}
function $54b47fc030b7b21e$var$stopEverything() {
    $54b47fc030b7b21e$var$clearIntervals();
    document.querySelectorAll("audio").forEach((el)=>{
        el.pause();
        el.currentTime = 0;
    });
}
/* =========================================================
   AUDIO — MUSIQUE PREMIER ÉCRAN
========================================================= */ function $54b47fc030b7b21e$var$stopFirstScreenMusic() {
    const music = document.getElementById("first-screen-music");
    music.pause();
    music.currentTime = 0;
}
function $54b47fc030b7b21e$var$playFirstScreenMusic() {
    const music = document.getElementById("first-screen-music");
    music.volume = $54b47fc030b7b21e$var$getVolume("first-screen-music");
    music.play().catch(()=>{
        document.addEventListener("click", ()=>{
            music.play().catch((err)=>console.log("Erreur first-screen-music:", err));
        }, {
            once: true
        });
    });
}
document.addEventListener("click", ()=>{
    if (!$54b47fc030b7b21e$var$firstMusicStarted) {
        $54b47fc030b7b21e$var$firstMusicStarted = true;
        $54b47fc030b7b21e$var$playFirstScreenMusic();
    }
}, {
    once: true
});
$54b47fc030b7b21e$var$playFirstScreenMusic();
/* =========================================================
   CAROUSEL — NORMAL
========================================================= */ function $54b47fc030b7b21e$var$updateCarousel() {
    $54b47fc030b7b21e$var$track.style.transform = `translateX(-${$54b47fc030b7b21e$var$index * 100}%)`;
}
/* =========================================================
   CAROUSEL — HARD
========================================================= */ function $54b47fc030b7b21e$var$updateCarouselHard() {
    $54b47fc030b7b21e$var$trackHard.style.transform = `translateX(-${$54b47fc030b7b21e$var$indexHard * 100}%)`;
}
/* =========================================================
   TIMER — NORMAL
========================================================= */ function $54b47fc030b7b21e$var$updateTimer() {
    const minutes = Math.floor($54b47fc030b7b21e$var$timeLeft / 60);
    const seconds = $54b47fc030b7b21e$var$timeLeft % 60;
    $54b47fc030b7b21e$var$timerElement.textContent = minutes + ":" + seconds.toString().padStart(2, "0");
    if ($54b47fc030b7b21e$var$timeLeft === 0 && !$54b47fc030b7b21e$var$alarmPlayed) {
        const alarm = document.getElementById("alarm-sound");
        alarm.currentTime = 0;
        alarm.volume = $54b47fc030b7b21e$var$getVolume("alarm-sound");
        alarm.play().catch((err)=>console.log("Erreur alarm-sound:", err));
        $54b47fc030b7b21e$var$alarmPlayed = true;
    }
    if ($54b47fc030b7b21e$var$timeLeft <= 30 && !$54b47fc030b7b21e$var$timeAlertPlayed) {
        const timeSound = document.getElementById("time-sound");
        timeSound.currentTime = 0;
        timeSound.volume = $54b47fc030b7b21e$var$getVolume("time-sound");
        timeSound.play().catch((err)=>console.log("Erreur time-sound:", err));
        $54b47fc030b7b21e$var$timeAlertPlayed = true;
    }
    if ($54b47fc030b7b21e$var$timeLeft > 0) $54b47fc030b7b21e$var$timeLeft--;
    else $54b47fc030b7b21e$var$endGame(true);
}
/* =========================================================
   TIMER — HARD
========================================================= */ function $54b47fc030b7b21e$var$updateTimerHard() {
    const minutes = Math.floor($54b47fc030b7b21e$var$timeLeft / 60);
    const seconds = $54b47fc030b7b21e$var$timeLeft % 60;
    $54b47fc030b7b21e$var$timerElementHard.textContent = minutes + ":" + seconds.toString().padStart(2, "0");
    if ($54b47fc030b7b21e$var$timeLeft <= 30 && !$54b47fc030b7b21e$var$timeAlertPlayed) {
        const timeSound = document.getElementById("time-sound");
        timeSound.currentTime = 0;
        timeSound.volume = $54b47fc030b7b21e$var$getVolume("time-sound");
        timeSound.play().catch((err)=>console.log("Erreur time-sound:", err));
        $54b47fc030b7b21e$var$timeAlertPlayed = true;
    }
    if ($54b47fc030b7b21e$var$timeLeft > 0) $54b47fc030b7b21e$var$timeLeft--;
    else $54b47fc030b7b21e$var$endGame(true);
}
/* =========================================================
   INTERVALS — CLEAR & START
========================================================= */ function $54b47fc030b7b21e$var$clearIntervals() {
    clearInterval($54b47fc030b7b21e$var$timerInterval);
    clearInterval($54b47fc030b7b21e$var$monsterInterval);
    clearInterval($54b47fc030b7b21e$var$glitchInterval);
    clearInterval($54b47fc030b7b21e$var$timestampInterval);
    clearInterval($54b47fc030b7b21e$var$doorInterval);
    clearInterval($54b47fc030b7b21e$var$objectInterval);
}
function $54b47fc030b7b21e$var$_buildDoorInterval() {
    const doorSounds = [
        "r-door-sound",
        "l-door-sound"
    ];
    const doorPlayCount = {
        "r-door-sound": 0,
        "l-door-sound": 0
    };
    function playRandomDoor() {
        const notEnough = doorSounds.filter((id)=>doorPlayCount[id] < 2);
        const pool = notEnough.length > 0 ? notEnough : doorSounds;
        const randomId = pool[Math.floor(Math.random() * pool.length)];
        const sound = document.getElementById(randomId);
        sound.currentTime = 0;
        sound.volume = $54b47fc030b7b21e$var$getVolume(randomId);
        sound.play().catch((err)=>console.log("Erreur door-sound:", err));
        doorPlayCount[randomId]++;
    }
    return setInterval(playRandomDoor, 25000);
}
function $54b47fc030b7b21e$var$startIntervals() {
    $54b47fc030b7b21e$var$timerInterval = setInterval($54b47fc030b7b21e$var$updateTimer, 1000);
    $54b47fc030b7b21e$var$monsterInterval = setInterval($54b47fc030b7b21e$var$spawnMonster, 10000);
    $54b47fc030b7b21e$var$doorInterval = $54b47fc030b7b21e$var$_buildDoorInterval();
}
function $54b47fc030b7b21e$var$startIntervalsHard() {
    $54b47fc030b7b21e$var$timerInterval = setInterval($54b47fc030b7b21e$var$updateTimerHard, 1000);
    setTimeout(()=>{
        $54b47fc030b7b21e$var$monsterInterval = setInterval($54b47fc030b7b21e$var$spawnMonsterHard, 10000);
        $54b47fc030b7b21e$var$objectInterval = setInterval($54b47fc030b7b21e$var$spawnObject, 12000);
    }, 30000);
    $54b47fc030b7b21e$var$doorInterval = $54b47fc030b7b21e$var$_buildDoorInterval();
}
/* =========================================================
   MONSTRES — SPAWN NORMAL
========================================================= */ function $54b47fc030b7b21e$var$buildMonsterQueue() {
    const allMonsters = Array.from(document.querySelectorAll(".monster-parent"));
    for(let i = allMonsters.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [allMonsters[i], allMonsters[j]] = [
            allMonsters[j],
            allMonsters[i]
        ];
    }
    if ($54b47fc030b7b21e$var$lastSpawnedMonster !== null && allMonsters[0] === $54b47fc030b7b21e$var$lastSpawnedMonster && allMonsters.length > 1) [allMonsters[0], allMonsters[1]] = [
        allMonsters[1],
        allMonsters[0]
    ];
    $54b47fc030b7b21e$var$monsterQueue = allMonsters;
}
function $54b47fc030b7b21e$var$spawnMonster() {
    if ($54b47fc030b7b21e$var$monsterQueue.length === 0) $54b47fc030b7b21e$var$buildMonsterQueue();
    let attempts = 0;
    while($54b47fc030b7b21e$var$monsterQueue.length > 0 && attempts < $54b47fc030b7b21e$var$monsterQueue.length){
        const monster = $54b47fc030b7b21e$var$monsterQueue.shift();
        if (monster.classList.contains("visible")) {
            $54b47fc030b7b21e$var$monsterQueue.push(monster);
            attempts++;
            continue;
        }
        monster.classList.add("visible");
        monster.style.opacity = "1";
        $54b47fc030b7b21e$var$lastSpawnedMonster = monster;
        $54b47fc030b7b21e$var$monsterCount++;
        if ($54b47fc030b7b21e$var$monsterCount >= 4) $54b47fc030b7b21e$var$endGame(false);
        return;
    }
}
/* =========================================================
   MONSTRES — SPAWN HARD
========================================================= */ function $54b47fc030b7b21e$var$buildMonsterQueueHard() {
    const allMonsters = Array.from($54b47fc030b7b21e$var$carouselHard.querySelectorAll(".monster-parent-hard"));
    for(let i = allMonsters.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [allMonsters[i], allMonsters[j]] = [
            allMonsters[j],
            allMonsters[i]
        ];
    }
    if ($54b47fc030b7b21e$var$lastSpawnedMonsterHard !== null && allMonsters[0] === $54b47fc030b7b21e$var$lastSpawnedMonsterHard && allMonsters.length > 1) [allMonsters[0], allMonsters[1]] = [
        allMonsters[1],
        allMonsters[0]
    ];
    $54b47fc030b7b21e$var$monsterQueueHard = allMonsters;
}
function $54b47fc030b7b21e$var$spawnMonsterHard() {
    if ($54b47fc030b7b21e$var$monsterQueueHard.length === 0) $54b47fc030b7b21e$var$buildMonsterQueueHard();
    let attempts = 0;
    while($54b47fc030b7b21e$var$monsterQueueHard.length > 0 && attempts < $54b47fc030b7b21e$var$monsterQueueHard.length){
        const monster = $54b47fc030b7b21e$var$monsterQueueHard.shift();
        if (monster.classList.contains("visible")) {
            $54b47fc030b7b21e$var$monsterQueueHard.push(monster);
            attempts++;
            continue;
        }
        monster.classList.add("visible");
        monster.style.opacity = "1";
        $54b47fc030b7b21e$var$lastSpawnedMonsterHard = monster;
        $54b47fc030b7b21e$var$monsterCount++;
        if ($54b47fc030b7b21e$var$monsterCount >= 4) $54b47fc030b7b21e$var$endGame(false);
        return;
    }
}
/* =========================================================
   OBJETS — SPAWN & RESET (MODE HARD)
========================================================= */ function $54b47fc030b7b21e$var$buildObjectQueue() {
    const allObjects = Array.from($54b47fc030b7b21e$var$carouselHard.querySelectorAll(".object-parent"));
    for(let i = allObjects.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [allObjects[i], allObjects[j]] = [
            allObjects[j],
            allObjects[i]
        ];
    }
    $54b47fc030b7b21e$var$objectQueue = allObjects;
}
function $54b47fc030b7b21e$var$spawnObject() {
    if ($54b47fc030b7b21e$var$objectQueue.length === 0) $54b47fc030b7b21e$var$buildObjectQueue();
    let obj = null;
    while($54b47fc030b7b21e$var$objectQueue.length > 0){
        const candidate = $54b47fc030b7b21e$var$objectQueue.shift();
        if (!candidate.classList.contains("visible")) {
            obj = candidate;
            break;
        }
    }
    if (!obj) return;
    obj.classList.add("visible");
    obj.style.opacity = "1";
    setTimeout(()=>{
        if (!obj.classList.contains("visible")) return;
        obj.classList.remove("visible");
        obj.style.opacity = "0";
        $54b47fc030b7b21e$var$missedObjects++;
        if ($54b47fc030b7b21e$var$missedObjects >= 6) $54b47fc030b7b21e$var$endGame(false);
    }, 20000);
}
function $54b47fc030b7b21e$var$resetObjectsHard() {
    $54b47fc030b7b21e$var$carouselHard.querySelectorAll(".object-parent").forEach((obj)=>{
        obj.classList.remove("visible", "found");
        obj.style.opacity = "1";
    });
    $54b47fc030b7b21e$var$objectQueue = [];
    $54b47fc030b7b21e$var$lastSpawnedObject = null;
    $54b47fc030b7b21e$var$objectCount = 0;
}
/* =========================================================
   HIT TEST — DÉTECTION PIXEL ALPHA (MONSTRES)
========================================================= */ function $54b47fc030b7b21e$var$setupMonsterClickTransparency(monsterImg) {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = monsterImg.src;
    img.onload = ()=>{
        const w = img.naturalWidth;
        const h = img.naturalHeight;
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        ctx.drawImage(img, 0, 0, w, h);
        $54b47fc030b7b21e$var$monsterRegistry.push({
            el: monsterImg,
            canvas: canvas,
            ctx: ctx
        });
    };
}
function $54b47fc030b7b21e$var$hitTest(e) {
    const x = e.clientX, y = e.clientY;
    $54b47fc030b7b21e$var$monsterRegistry.forEach(({ el: el, canvas: canvas, ctx: ctx })=>{
        const r = el.getBoundingClientRect();
        if (x < r.left || x > r.right || y < r.top || y > r.bottom) {
            el.style.pointerEvents = "auto";
            return;
        }
        const px = Math.floor((x - r.left) * canvas.width / r.width);
        const py = Math.floor((y - r.top) * canvas.height / r.height);
        const alpha = ctx.getImageData(px, py, 1, 1).data[3] / 255;
        el.style.pointerEvents = alpha <= $54b47fc030b7b21e$var$TRANSPARENCY_THRESHOLD ? "none" : "auto";
    });
}
if (window.PointerEvent) {
    document.addEventListener("pointermove", $54b47fc030b7b21e$var$hitTest, {
        passive: true
    });
    document.addEventListener("pointerdown", $54b47fc030b7b21e$var$hitTest, {
        passive: true
    });
} else {
    document.addEventListener("touchmove", $54b47fc030b7b21e$var$hitTest, {
        passive: true
    });
    document.addEventListener("touchstart", $54b47fc030b7b21e$var$hitTest, {
        passive: true
    });
}
/* =========================================================
   HIT TEST — DÉTECTION MONSTRE SOUS LE CURSEUR (NORMAL)
========================================================= */ function $54b47fc030b7b21e$var$getVisibleMonsterAtPoint(cx, cy) {
    const visibleMonsters = Array.from(document.querySelectorAll(".monster-parent.visible"));
    for (const monster of visibleMonsters){
        const rect = monster.getBoundingClientRect();
        if (cx < rect.left || cx > rect.right || cy < rect.top || cy > rect.bottom) continue;
        const canvas = document.createElement("canvas");
        canvas.width = monster.naturalWidth;
        canvas.height = monster.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(monster, 0, 0);
        const x = Math.floor((cx - rect.left) / rect.width * monster.naturalWidth);
        const y = Math.floor((cy - rect.top) / rect.height * monster.naturalHeight);
        try {
            const pixel = ctx.getImageData(x, y, 1, 1).data;
            if (pixel[3] >= 25) return monster;
        } catch  {
            return monster;
        }
    }
    return null;
}
/* =========================================================
   HIT TEST — DÉTECTION MONSTRE SOUS LE CURSEUR (HARD)
========================================================= */ function $54b47fc030b7b21e$var$getVisibleMonsterAtPointHard(cx, cy) {
    const visibleMonsters = Array.from($54b47fc030b7b21e$var$carouselHard.querySelectorAll(".monster-parent-hard.visible"));
    for (const monster of visibleMonsters){
        const rect = monster.getBoundingClientRect();
        if (cx < rect.left || cx > rect.right || cy < rect.top || cy > rect.bottom) continue;
        const canvas = document.createElement("canvas");
        canvas.width = monster.naturalWidth;
        canvas.height = monster.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(monster, 0, 0);
        const x = Math.floor((cx - rect.left) / rect.width * monster.naturalWidth);
        const y = Math.floor((cy - rect.top) / rect.height * monster.naturalHeight);
        try {
            const pixel = ctx.getImageData(x, y, 1, 1).data;
            if (pixel[3] >= 25) return monster;
        } catch  {
            return monster;
        }
    }
    return null;
}
/* =========================================================
   HIT TEST — DÉTECTION OBJET SOUS LE CURSEUR (HARD)
========================================================= */ function $54b47fc030b7b21e$var$getVisibleObjectAtPointHard(cx, cy) {
    const objects = Array.from($54b47fc030b7b21e$var$carouselHard.querySelectorAll(".object-parent:not(.found)"));
    for (const obj of objects){
        const rect = obj.getBoundingClientRect();
        if (cx < rect.left || cx > rect.right || cy < rect.top || cy > rect.bottom) continue;
        const canvas = document.createElement("canvas");
        canvas.width = obj.naturalWidth || 1;
        canvas.height = obj.naturalHeight || 1;
        const ctx = canvas.getContext("2d");
        try {
            ctx.drawImage(obj, 0, 0);
            const x = Math.floor((cx - rect.left) / rect.width * (obj.naturalWidth || 1));
            const y = Math.floor((cy - rect.top) / rect.height * (obj.naturalHeight || 1));
            const pixel = ctx.getImageData(x, y, 1, 1).data;
            if (pixel[3] >= 25) return obj;
        } catch  {
            return obj;
        }
    }
    return null;
}
/* =========================================================
   UI — BLACKOUT HELPER
========================================================= */ function $54b47fc030b7b21e$var$createBlackout(fadeIn, callback) {
    const blackout = document.createElement("div");
    blackout.style.cssText = `
    position: fixed;
    inset: 0;
    background: black;
    z-index: 9999;
    opacity: ${fadeIn ? "0" : "1"};
    transition: opacity 1s ease;
    pointer-events: none;
    overflow: hidden;
  `;
    const scanLine = document.createElement("div");
    scanLine.style.cssText = `
    position: absolute;
    left: 0; right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
    animation: blackout-scan 1.2s linear infinite;
    opacity: 0.5;
  `;
    const style = document.createElement("style");
    style.textContent = `
    @keyframes blackout-scan {
      0%   { top: -2px; }
      100% { top: 100%; }
    }
  `;
    document.head.appendChild(style);
    blackout.appendChild(scanLine);
    document.body.appendChild(blackout);
    requestAnimationFrame(()=>{
        blackout.style.opacity = fadeIn ? "1" : "0";
    });
    setTimeout(()=>{
        blackout.remove();
        style.remove();
        if (callback) callback();
    }, 1200);
}
/* =========================================================
   UI — LOADING BAR
========================================================= */ const $54b47fc030b7b21e$var$loadingBar = document.createElement("div");
$54b47fc030b7b21e$var$loadingBar.style.cssText = `
  position: fixed;
  pointer-events: none;
  z-index: 9999;
  width: 80px;
  height: 7px;
  background: rgba(0, 255, 65, 0.2);
  border: 1px solid rgba(0, 255, 65, 0.4);
  display: none;
  overflow: hidden;
`;
const $54b47fc030b7b21e$var$loadingFill = document.createElement("div");
$54b47fc030b7b21e$var$loadingFill.style.cssText = `
  height: 100%;
  width: 0%;
  background: #00ff41;
  box-shadow: 0 0 6px #00ff41, 0 0 12px rgba(0,255,65,0.5);
`;
$54b47fc030b7b21e$var$loadingBar.appendChild($54b47fc030b7b21e$var$loadingFill);
document.body.appendChild($54b47fc030b7b21e$var$loadingBar);
function $54b47fc030b7b21e$var$moveBar(cx, cy) {
    $54b47fc030b7b21e$var$loadingBar.style.left = cx - 40 + "px";
    $54b47fc030b7b21e$var$loadingBar.style.top = cy + 35 + "px";
}
/* =========================================================
   UI — FAUX CURSEUR (boutons disabled)
========================================================= */ const $54b47fc030b7b21e$var$fakeCursor = document.createElement("div");
$54b47fc030b7b21e$var$fakeCursor.style.cssText = `
  position: fixed;
  pointer-events: none;
  z-index: 9999;
  display: none;
  width: 60px;
  height: 60px;
`;
$54b47fc030b7b21e$var$fakeCursor.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
  <line x1="2"  y1="2"  x2="14" y2="14" stroke="red" stroke-width="2.5"/>
  <line x1="14" y1="2"  x2="2"  y2="14" stroke="red" stroke-width="2.5"/>
</svg>`;
document.body.appendChild($54b47fc030b7b21e$var$fakeCursor);
let $54b47fc030b7b21e$var$shakeFrame = null;
let $54b47fc030b7b21e$var$mouseX = 0;
let $54b47fc030b7b21e$var$mouseY = 0;
document.querySelectorAll("button[disabled]").forEach((btn)=>{
    btn.addEventListener("mouseenter", ()=>{
        $54b47fc030b7b21e$var$fakeCursor.style.display = "block";
        let t = 0;
        function animateShake() {
            const dx = Math.sin(t * 0.8) * 4;
            const dy = Math.cos(t * 1.1) * 3;
            $54b47fc030b7b21e$var$fakeCursor.style.left = $54b47fc030b7b21e$var$mouseX + dx - 8 + "px";
            $54b47fc030b7b21e$var$fakeCursor.style.top = $54b47fc030b7b21e$var$mouseY + dy - 8 + "px";
            t += 0.4;
            $54b47fc030b7b21e$var$shakeFrame = requestAnimationFrame(animateShake);
        }
        animateShake();
    });
    btn.addEventListener("mouseleave", ()=>{
        $54b47fc030b7b21e$var$fakeCursor.style.display = "none";
        cancelAnimationFrame($54b47fc030b7b21e$var$shakeFrame);
    });
});
document.addEventListener("mousemove", (e)=>{
    $54b47fc030b7b21e$var$mouseX = e.clientX;
    $54b47fc030b7b21e$var$mouseY = e.clientY;
});
/* =========================================================
   HOLD LOGIC — HELPER PARTAGÉ
   Gère la barre de chargement + son + timeout de 2s
   Retourne { cancel } pour annuler depuis l'extérieur.
========================================================= */ function $54b47fc030b7b21e$var$startHold(cx, cy, onComplete, onCancel) {
    let isHolding = true;
    $54b47fc030b7b21e$var$moveBar(cx, cy);
    $54b47fc030b7b21e$var$loadingBar.style.display = "block";
    $54b47fc030b7b21e$var$loadingFill.style.transition = "none";
    $54b47fc030b7b21e$var$loadingFill.style.width = "0%";
    const loadingSound = document.getElementById("loading-sound");
    loadingSound.currentTime = 0;
    loadingSound.volume = $54b47fc030b7b21e$var$getVolume("loading-sound");
    loadingSound.play().catch((err)=>console.log("Erreur loading-sound:", err));
    requestAnimationFrame(()=>{
        $54b47fc030b7b21e$var$loadingFill.style.transition = "width 2000ms linear";
        $54b47fc030b7b21e$var$loadingFill.style.width = "100%";
    });
    function onMove(ev) {
        if (!isHolding) return;
        $54b47fc030b7b21e$var$moveBar(ev.clientX, ev.clientY);
    }
    function cancelHold() {
        if (!isHolding) return;
        isHolding = false;
        clearTimeout(holdTimeout);
        $54b47fc030b7b21e$var$loadingFill.style.transition = "none";
        $54b47fc030b7b21e$var$loadingFill.style.width = "0%";
        $54b47fc030b7b21e$var$loadingBar.style.display = "none";
        loadingSound.pause();
        loadingSound.currentTime = 0;
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", cancelHold);
        if (onCancel) onCancel();
    }
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", cancelHold);
    const holdTimeout = setTimeout(()=>{
        if (!isHolding) return;
        isHolding = false;
        $54b47fc030b7b21e$var$loadingFill.style.transition = "none";
        $54b47fc030b7b21e$var$loadingFill.style.width = "0%";
        $54b47fc030b7b21e$var$loadingBar.style.display = "none";
        loadingSound.pause();
        loadingSound.currentTime = 0;
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", cancelHold);
        onComplete();
    }, 2000);
    return {
        cancel: cancelHold
    };
}
/* =========================================================
   HOLD LOGIC — EFFETS GLITCH POST-ÉLIMINATION
========================================================= */ function $54b47fc030b7b21e$var$playGlitchEffect(container, withVideo) {
    container.classList.add("screen-glitch");
    const scanEl = document.createElement("div");
    scanEl.className = "screen-glitch-scan";
    container.appendChild(scanEl);
    const lineEl = document.createElement("div");
    lineEl.className = "screen-glitch-line";
    container.appendChild(lineEl);
    if (withVideo) {
        const glitchVideo = document.createElement("video");
        glitchVideo.src = "glitch1.mp4";
        glitchVideo.autoplay = true;
        glitchVideo.muted = true;
        glitchVideo.style.cssText = `
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.3;
      z-index: 102;
      pointer-events: none;
    `;
        container.appendChild(glitchVideo);
        setTimeout(()=>{
            container.classList.remove("screen-glitch");
            scanEl.remove();
            lineEl.remove();
            glitchVideo.remove();
        }, 2000);
    } else setTimeout(()=>{
        container.classList.remove("screen-glitch");
        scanEl.remove();
        lineEl.remove();
    }, 2000);
    const glitchSound = document.getElementById("monster-glitch-sound");
    glitchSound.currentTime = 0;
    glitchSound.volume = $54b47fc030b7b21e$var$getVolume("monster-glitch-sound");
    glitchSound.play();
}
/* =========================================================
   HOLD LOGIC — CROIX ROUGE (clic dans le vide)
========================================================= */ function $54b47fc030b7b21e$var$showMissedCross(cx, cy) {
    const missedSound = document.getElementById("missed-sound");
    missedSound.currentTime = 0;
    missedSound.volume = $54b47fc030b7b21e$var$getVolume("missed-sound");
    missedSound.play().catch((err)=>console.log("Erreur missed-sound:", err));
    document.body.classList.add("cursor-locked");
    const shakeCross = document.createElement("div");
    shakeCross.style.cssText = `
    position: fixed;
    pointer-events: none;
    z-index: 9999;
    left: ${cx - 10}px;
    top:  ${cy - 10}px;
  `;
    shakeCross.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
    <line x1="2"  y1="2"  x2="14" y2="14" stroke="red" stroke-width="2.5"/>
    <line x1="14" y1="2"  x2="2"  y2="14" stroke="red" stroke-width="2.5"/>
  </svg>`;
    shakeCross.classList.add("cross-visible");
    document.body.appendChild(shakeCross);
    function followMouse(ev) {
        shakeCross.style.left = ev.clientX - 10 + "px";
        shakeCross.style.top = ev.clientY - 10 + "px";
    }
    document.addEventListener("mousemove", followMouse);
    setTimeout(()=>{
        shakeCross.remove();
        document.body.classList.remove("cursor-locked");
        document.removeEventListener("mousemove", followMouse);
    }, 800);
}
/* =========================================================
   CAROUSEL MOUSEDOWN — NORMAL
========================================================= */ document.getElementById("carousel").addEventListener("mousedown", (e)=>{
    if (e.button !== 0) return;
    if (e.target.closest("button, #timer, .text, .text-battery")) return;
    const cx = e.clientX;
    const cy = e.clientY;
    const hitMonster = $54b47fc030b7b21e$var$getVisibleMonsterAtPoint(cx, cy);
    if (hitMonster) $54b47fc030b7b21e$var$startHold(cx, cy, ()=>{
        hitMonster.classList.remove("visible");
        hitMonster.style.opacity = "0";
        $54b47fc030b7b21e$var$monsterCount--;
        if ($54b47fc030b7b21e$var$monsterCount < 0) $54b47fc030b7b21e$var$monsterCount = 0;
        $54b47fc030b7b21e$var$playGlitchEffect($54b47fc030b7b21e$var$carousel, true);
    });
    else {
        let lastCx = cx, lastCy = cy;
        $54b47fc030b7b21e$var$startHold(cx, cy, ()=>$54b47fc030b7b21e$var$showMissedCross(lastCx, lastCy), null);
        // suivi du curseur pendant le hold vide
        function trackVoid(ev) {
            lastCx = ev.clientX;
            lastCy = ev.clientY;
        }
        document.addEventListener("mousemove", trackVoid);
        document.addEventListener("mouseup", ()=>{
            document.removeEventListener("mousemove", trackVoid);
        }, {
            once: true
        });
    }
});
/* =========================================================
   CAROUSEL MOUSEDOWN — HARD
========================================================= */ $54b47fc030b7b21e$var$carouselHard.addEventListener("mousedown", (e)=>{
    if (e.button !== 0) return;
    if (e.target.closest("button, #timer-hard, .text-hard, .text-battery-hard")) return;
    const cx = e.clientX;
    const cy = e.clientY;
    const hitMonster = $54b47fc030b7b21e$var$getVisibleMonsterAtPointHard(cx, cy);
    const hitObject = $54b47fc030b7b21e$var$getVisibleObjectAtPointHard(cx, cy);
    if (!hitMonster && hitObject) {
        $54b47fc030b7b21e$var$startHold(cx, cy, ()=>{
            $54b47fc030b7b21e$var$missedObjects--;
            if ($54b47fc030b7b21e$var$missedObjects < 0) $54b47fc030b7b21e$var$missedObjects = 0;
            hitObject.classList.add("visible");
            hitObject.style.opacity = "1";
            setTimeout(()=>{
                hitObject.classList.remove("visible");
                hitObject.style.opacity = "0";
            }, 20000);
            $54b47fc030b7b21e$var$playGlitchEffect($54b47fc030b7b21e$var$carouselHard, false);
        });
        return;
    }
    if (hitMonster) $54b47fc030b7b21e$var$startHold(cx, cy, ()=>{
        hitMonster.classList.remove("visible");
        hitMonster.style.opacity = "0";
        $54b47fc030b7b21e$var$monsterCount--;
        if ($54b47fc030b7b21e$var$monsterCount < 0) $54b47fc030b7b21e$var$monsterCount = 0;
        $54b47fc030b7b21e$var$playGlitchEffect($54b47fc030b7b21e$var$carouselHard, true);
    });
    else {
        let lastCx = cx, lastCy = cy;
        $54b47fc030b7b21e$var$startHold(cx, cy, ()=>$54b47fc030b7b21e$var$showMissedCross(lastCx, lastCy), null);
        function trackVoid(ev) {
            lastCx = ev.clientX;
            lastCy = ev.clientY;
        }
        document.addEventListener("mousemove", trackVoid);
        document.addEventListener("mouseup", ()=>{
            document.removeEventListener("mousemove", trackVoid);
        }, {
            once: true
        });
    }
});
$54b47fc030b7b21e$var$carouselHard.addEventListener("dragstart", (e)=>e.preventDefault());
/* =========================================================
   LOGIQUE DE JEU — START / PAUSE / RESUME / END
========================================================= */ function $54b47fc030b7b21e$var$startGame() {
    $54b47fc030b7b21e$var$startScreen.style.display = "none";
    $54b47fc030b7b21e$var$firstScreen.style.display = "none";
    $54b47fc030b7b21e$var$gameOverScreen.style.display = "none";
    $54b47fc030b7b21e$var$pauseMenu.style.display = "none";
    $54b47fc030b7b21e$var$carousel.style.display = "block";
    $54b47fc030b7b21e$var$menuButton.style.display = "block";
    $54b47fc030b7b21e$var$timeLeft = 120;
    $54b47fc030b7b21e$var$monsterCount = 0;
    $54b47fc030b7b21e$var$monsterQueue = [];
    $54b47fc030b7b21e$var$lastSpawnedMonster = null;
    $54b47fc030b7b21e$var$timeAlertPlayed = false;
    $54b47fc030b7b21e$var$alarmPlayed = false;
    const ambianceMusic = document.getElementById("ambiance-music");
    ambianceMusic.volume = $54b47fc030b7b21e$var$getVolume("ambiance-music");
    ambianceMusic.currentTime = 0;
    ambianceMusic.play().catch((err)=>console.log("Erreur ambiance-music:", err));
    $54b47fc030b7b21e$var$clearIntervals();
    document.getElementById("tuto-normal").style.display = "flex";
    $54b47fc030b7b21e$var$createBlackout(false);
}
function $54b47fc030b7b21e$var$startGameHard() {
    $54b47fc030b7b21e$var$resetObjectsHard();
    $54b47fc030b7b21e$var$startScreen.style.display = "none";
    $54b47fc030b7b21e$var$firstScreen.style.display = "none";
    $54b47fc030b7b21e$var$gameOverScreen.style.display = "none";
    $54b47fc030b7b21e$var$pauseMenu.style.display = "none";
    $54b47fc030b7b21e$var$carousel.style.display = "none";
    $54b47fc030b7b21e$var$carouselHard.style.display = "block";
    $54b47fc030b7b21e$var$menuButton.style.display = "block";
    $54b47fc030b7b21e$var$timeLeft = 240;
    $54b47fc030b7b21e$var$monsterCount = 0;
    $54b47fc030b7b21e$var$missedObjects = 0;
    $54b47fc030b7b21e$var$monsterQueueHard = [];
    $54b47fc030b7b21e$var$lastSpawnedMonsterHard = null;
    $54b47fc030b7b21e$var$timeAlertPlayed = false;
    $54b47fc030b7b21e$var$timerElementHard.textContent = "4:00";
    const ambianceMusic = document.getElementById("ambiance-music");
    ambianceMusic.volume = $54b47fc030b7b21e$var$getVolume("ambiance-music");
    ambianceMusic.currentTime = 0;
    ambianceMusic.play().catch((err)=>console.log("Erreur ambiance-music:", err));
    $54b47fc030b7b21e$var$clearIntervals();
    document.getElementById("tuto-hard").style.display = "flex";
    $54b47fc030b7b21e$var$createBlackout(false);
}
function $54b47fc030b7b21e$var$pauseGame() {
    $54b47fc030b7b21e$var$clearIntervals();
    $54b47fc030b7b21e$var$menuButton.style.display = "none";
    document.getElementById("ambiance-music").pause();
    $54b47fc030b7b21e$var$pauseTitle.innerHTML = `PAUSED<span class="point-animation-p">.</span>`;
    $54b47fc030b7b21e$var$pauseMainButtons.style.display = "flex";
    $54b47fc030b7b21e$var$settingsMain.style.display = "none";
    $54b47fc030b7b21e$var$panelGraphics.style.display = "none";
    $54b47fc030b7b21e$var$panelSound.style.display = "none";
    $54b47fc030b7b21e$var$panelControls.style.display = "none";
    $54b47fc030b7b21e$var$pauseMenu.style.display = "flex";
}
function $54b47fc030b7b21e$var$resumeGame() {
    $54b47fc030b7b21e$var$pauseMenu.style.display = "none";
    $54b47fc030b7b21e$var$menuButton.style.display = "block";
    $54b47fc030b7b21e$var$startIntervals();
    const ambianceMusic = document.getElementById("ambiance-music");
    ambianceMusic.volume = $54b47fc030b7b21e$var$getVolume("ambiance-music");
    ambianceMusic.play();
}
function $54b47fc030b7b21e$var$endGame(won) {
    $54b47fc030b7b21e$var$clearIntervals();
    $54b47fc030b7b21e$var$stopAllSounds();
    if (!won) {
        const deadSound = document.getElementById("dead-sound");
        const iiiiSound = document.getElementById("iiii-sound");
        iiiiSound.currentTime = 0;
        iiiiSound.volume = $54b47fc030b7b21e$var$getVolume("iiii-sound");
        iiiiSound.play().catch((err)=>console.log("Erreur iiii-sound:", err));
        deadSound.currentTime = 0;
        deadSound.volume = $54b47fc030b7b21e$var$getVolume("dead-sound");
        deadSound.play().catch((err)=>console.log("Erreur dead-sound:", err));
        $54b47fc030b7b21e$var$createBlackout(true, ()=>{
            $54b47fc030b7b21e$var$carousel.style.display = "none";
            document.getElementById("carousel-hard").style.display = "none";
            $54b47fc030b7b21e$var$pauseMenu.style.display = "none";
            $54b47fc030b7b21e$var$gameOverScreen.style.display = "flex";
            $54b47fc030b7b21e$var$menuButton.style.display = "none";
            $54b47fc030b7b21e$var$gameOverMessage.innerHTML = "FAILED...";
        });
        return;
    }
    $54b47fc030b7b21e$var$createBlackout(true, ()=>{
        $54b47fc030b7b21e$var$carousel.style.display = "none";
        document.getElementById("carousel-hard").style.display = "none";
        $54b47fc030b7b21e$var$pauseMenu.style.display = "none";
        $54b47fc030b7b21e$var$gameOverScreen.style.display = "flex";
        $54b47fc030b7b21e$var$menuButton.style.display = "none";
        $54b47fc030b7b21e$var$gameOverMessage.innerHTML = `It's Gone... <span class="for-now-glow">For Now</span>`;
        const winSound = document.getElementById("win-sound");
        winSound.currentTime = 0;
        winSound.volume = $54b47fc030b7b21e$var$getVolume("win-sound");
        winSound.play().catch((err)=>console.log("Erreur win-sound:", err));
    });
}
function $54b47fc030b7b21e$var$resetGame() {
    $54b47fc030b7b21e$var$stopAllSounds();
    $54b47fc030b7b21e$var$index = 0;
    $54b47fc030b7b21e$var$timeLeft = 120;
    $54b47fc030b7b21e$var$monsterCount = 0;
    $54b47fc030b7b21e$var$objectCount = 0;
    $54b47fc030b7b21e$var$timeAlertPlayed = false;
    $54b47fc030b7b21e$var$alarmPlayed = false;
    $54b47fc030b7b21e$var$monsterQueue = [];
    $54b47fc030b7b21e$var$lastSpawnedMonster = null;
    $54b47fc030b7b21e$var$timerElement.textContent = "2:00";
    document.querySelectorAll(".monster-parent").forEach((monster)=>{
        monster.classList.remove("visible");
        monster.style.opacity = "0";
    });
    document.querySelectorAll(".object-parent").forEach((obj)=>{
        obj.classList.remove("visible");
        obj.style.opacity = "0";
    });
    $54b47fc030b7b21e$var$updateCarousel();
    $54b47fc030b7b21e$var$gameOverScreen.style.display = "none";
    $54b47fc030b7b21e$var$carousel.style.display = "block";
    $54b47fc030b7b21e$var$menuButton.style.display = "block";
    const ambianceMusic = document.getElementById("ambiance-music");
    ambianceMusic.volume = $54b47fc030b7b21e$var$getVolume("ambiance-music");
    ambianceMusic.currentTime = 0;
    ambianceMusic.play().catch((err)=>console.log("Erreur ambiance-music:", err));
    $54b47fc030b7b21e$var$clearIntervals();
    $54b47fc030b7b21e$var$startIntervals();
    $54b47fc030b7b21e$var$createBlackout(false);
}
function $54b47fc030b7b21e$var$backToMenu() {
    $54b47fc030b7b21e$var$clearIntervals();
    $54b47fc030b7b21e$var$stopAllSounds();
    $54b47fc030b7b21e$var$index = 0;
    $54b47fc030b7b21e$var$timeLeft = 120;
    $54b47fc030b7b21e$var$monsterCount = 0;
    $54b47fc030b7b21e$var$objectCount = 0;
    $54b47fc030b7b21e$var$monsterQueue = [];
    $54b47fc030b7b21e$var$lastSpawnedMonster = null;
    $54b47fc030b7b21e$var$timeAlertPlayed = false;
    $54b47fc030b7b21e$var$alarmPlayed = false;
    $54b47fc030b7b21e$var$resetObjectsHard();
    $54b47fc030b7b21e$var$timerElement.textContent = "2:00";
    document.querySelectorAll(".monster-parent").forEach((monster)=>{
        monster.classList.remove("visible");
        monster.style.opacity = "0";
    });
    document.querySelectorAll(".object-parent").forEach((obj)=>{
        obj.classList.remove("visible");
        obj.style.opacity = "0";
    });
    $54b47fc030b7b21e$var$updateCarousel();
    $54b47fc030b7b21e$var$carousel.style.display = "none";
    document.getElementById("carousel-hard").style.display = "none";
    $54b47fc030b7b21e$var$gameOverScreen.style.display = "none";
    $54b47fc030b7b21e$var$pauseMenu.style.display = "none";
    $54b47fc030b7b21e$var$startScreen.style.display = "none";
    $54b47fc030b7b21e$var$firstScreen.style.display = "flex";
    $54b47fc030b7b21e$var$menuButton.style.display = "none";
    $54b47fc030b7b21e$var$resetSettings();
    $54b47fc030b7b21e$var$playFirstScreenMusic();
}
/* =========================================================
   SETTINGS — FONCTIONS
========================================================= */ function $54b47fc030b7b21e$var$resetSettings() {
    $54b47fc030b7b21e$var$masterVolume = 0.5;
    $54b47fc030b7b21e$var$musicVolume = 0.5;
    $54b47fc030b7b21e$var$clickVolume = 0.5;
    document.getElementById("master-slider").value = 50;
    document.getElementById("music-slider").value = 50;
    document.getElementById("click-slider").value = 50;
    document.getElementById("master-value").textContent = "50%";
    document.getElementById("music-value").textContent = "50%";
    document.getElementById("click-value").textContent = "50%";
    document.getElementById("brightness-slider").value = 50;
    document.getElementById("brightness-value").textContent = "50%";
    document.querySelectorAll(".carousel-track img:not(.monster-parent)").forEach((img)=>{
        img.style.filter = "brightness(1)";
    });
    $54b47fc030b7b21e$var$sensitivity = 5;
    document.getElementById("sensitivity-slider").value = 5;
    document.getElementById("sensitivity-value").textContent = "5";
}
function $54b47fc030b7b21e$var$showPauseMain() {
    if ($54b47fc030b7b21e$var$settingsFromFirst) {
        $54b47fc030b7b21e$var$settingsFromFirst = false;
        $54b47fc030b7b21e$var$pauseMenu.style.display = "none";
        $54b47fc030b7b21e$var$firstScreen.style.display = "flex";
        const music = document.getElementById("first-screen-music");
        if (music.paused) music.play().catch((err)=>console.log("Erreur first-screen-music:", err));
        return;
    }
    $54b47fc030b7b21e$var$pauseTitle.innerHTML = `PAUSED<span class="point-animation-p">.</span>`;
    $54b47fc030b7b21e$var$pauseMainButtons.style.display = "flex";
    $54b47fc030b7b21e$var$settingsMain.style.display = "none";
    $54b47fc030b7b21e$var$panelGraphics.style.display = "none";
    $54b47fc030b7b21e$var$panelSound.style.display = "none";
    $54b47fc030b7b21e$var$panelControls.style.display = "none";
}
function $54b47fc030b7b21e$var$showSettingsMain() {
    $54b47fc030b7b21e$var$pauseTitle.innerHTML = `SETTINGS<span class="point-animation-p">.</span>`;
    $54b47fc030b7b21e$var$pauseMainButtons.style.display = "none";
    $54b47fc030b7b21e$var$settingsMain.style.display = "flex";
    $54b47fc030b7b21e$var$panelGraphics.style.display = "none";
    $54b47fc030b7b21e$var$panelSound.style.display = "none";
    $54b47fc030b7b21e$var$panelControls.style.display = "none";
}
function $54b47fc030b7b21e$var$showPanel(panel, title) {
    $54b47fc030b7b21e$var$pauseTitle.innerHTML = `${title}<span class="point-animation-p">.</span>`;
    $54b47fc030b7b21e$var$settingsMain.style.display = "none";
    panel.style.display = "flex";
}
/* =========================================================
   SETTINGS — EVENT LISTENERS
========================================================= */ document.getElementById("setting-button").addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$settingsFromFirst = false;
    $54b47fc030b7b21e$var$showSettingsMain();
});
document.getElementById("settings-back").addEventListener("click", $54b47fc030b7b21e$var$showPauseMain);
document.getElementById("btn-graphics").addEventListener("click", ()=>$54b47fc030b7b21e$var$showPanel($54b47fc030b7b21e$var$panelGraphics, "GRAPHIC"));
document.getElementById("btn-sound").addEventListener("click", ()=>$54b47fc030b7b21e$var$showPanel($54b47fc030b7b21e$var$panelSound, "SOUNDS"));
document.getElementById("btn-controls").addEventListener("click", ()=>$54b47fc030b7b21e$var$showPanel($54b47fc030b7b21e$var$panelControls, "CONTROL"));
document.querySelectorAll(".panel-back").forEach((btn)=>{
    btn.addEventListener("click", $54b47fc030b7b21e$var$showSettingsMain);
});
document.getElementById("brightness-slider").addEventListener("input", (e)=>{
    document.querySelectorAll(".carousel-track img:not(.monster-parent)").forEach((img)=>{
        img.style.filter = `brightness(${e.target.value / 100})`;
    });
    document.getElementById("brightness-value").textContent = e.target.value + "%";
});
document.getElementById("sensitivity-slider").addEventListener("input", (e)=>{
    $54b47fc030b7b21e$var$sensitivity = parseInt(e.target.value);
    document.getElementById("sensitivity-value").textContent = $54b47fc030b7b21e$var$sensitivity;
});
document.getElementById("master-slider").addEventListener("input", (e)=>{
    $54b47fc030b7b21e$var$masterVolume = e.target.value / 100;
    document.getElementById("master-value").textContent = e.target.value + "%";
    $54b47fc030b7b21e$var$applyVolumes();
});
document.getElementById("music-slider").addEventListener("input", (e)=>{
    $54b47fc030b7b21e$var$musicVolume = e.target.value / 100;
    document.getElementById("music-value").textContent = e.target.value + "%";
    $54b47fc030b7b21e$var$applyVolumes();
});
document.getElementById("click-slider").addEventListener("input", (e)=>{
    $54b47fc030b7b21e$var$clickVolume = e.target.value / 100;
    document.getElementById("click-value").textContent = e.target.value + "%";
    $54b47fc030b7b21e$var$applyVolumes();
});
document.querySelectorAll("input[type='range']").forEach((slider)=>{
    slider.addEventListener("mousedown", ()=>slider.classList.add("dragging"));
    document.addEventListener("mouseup", ()=>slider.classList.remove("dragging"));
});
/* =========================================================
   BOUTONS PRINCIPAUX — EVENT LISTENERS
========================================================= */ $54b47fc030b7b21e$var$menuButton.addEventListener("click", $54b47fc030b7b21e$var$pauseGame);
$54b47fc030b7b21e$var$resumeButton.addEventListener("click", $54b47fc030b7b21e$var$resumeGame);
$54b47fc030b7b21e$var$quitButton.addEventListener("click", $54b47fc030b7b21e$var$backToMenu);
$54b47fc030b7b21e$var$restartButton.addEventListener("click", $54b47fc030b7b21e$var$resetGame);
$54b47fc030b7b21e$var$backButton.addEventListener("click", $54b47fc030b7b21e$var$backToMenu);
document.getElementById("level-button").addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$firstScreen.style.display = "none";
    $54b47fc030b7b21e$var$startScreen.style.display = "flex";
});
document.getElementById("back-to-first").addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$startScreen.style.display = "none";
    $54b47fc030b7b21e$var$firstScreen.style.display = "flex";
});
document.getElementById("setting-button-first").addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$firstScreen.style.display = "none";
    $54b47fc030b7b21e$var$pauseMenu.style.display = "flex";
    $54b47fc030b7b21e$var$settingsFromFirst = true;
    $54b47fc030b7b21e$var$showSettingsMain();
});
document.getElementById("skip-button").addEventListener("click", ()=>{
    document.getElementById("tuto-normal").style.display = "none";
    $54b47fc030b7b21e$var$startIntervals();
});
document.getElementById("skip-button-hard").addEventListener("click", ()=>{
    document.getElementById("tuto-hard").style.display = "none";
    $54b47fc030b7b21e$var$startIntervalsHard();
});
$54b47fc030b7b21e$var$difficultyButtons.forEach((button)=>{
    if (button.getAttribute("data-difficulty") === "normal") button.addEventListener("click", ()=>{
        $54b47fc030b7b21e$var$stopFirstScreenMusic();
        $54b47fc030b7b21e$var$startGame();
    });
});
document.querySelector("[data-difficulty='hard']").addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$stopFirstScreenMusic();
    $54b47fc030b7b21e$var$startGameHard();
});
/* =========================================================
   CAROUSEL — NAVIGATION (flèches)
========================================================= */ const $54b47fc030b7b21e$var$cameraSound = document.getElementById("camera-sound");
$54b47fc030b7b21e$var$btnRight.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$index = ($54b47fc030b7b21e$var$index + 1) % $54b47fc030b7b21e$var$rooms.length;
    $54b47fc030b7b21e$var$updateCarousel();
    $54b47fc030b7b21e$var$cameraSound.currentTime = 0;
    $54b47fc030b7b21e$var$cameraSound.volume = $54b47fc030b7b21e$var$getVolume("camera-sound");
    $54b47fc030b7b21e$var$cameraSound.play();
});
$54b47fc030b7b21e$var$btnLeft.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$index = ($54b47fc030b7b21e$var$index - 1 + $54b47fc030b7b21e$var$rooms.length) % $54b47fc030b7b21e$var$rooms.length;
    $54b47fc030b7b21e$var$updateCarousel();
    $54b47fc030b7b21e$var$cameraSound.currentTime = 0;
    $54b47fc030b7b21e$var$cameraSound.volume = $54b47fc030b7b21e$var$getVolume("camera-sound");
    $54b47fc030b7b21e$var$cameraSound.play();
});
$54b47fc030b7b21e$var$btnRightHard.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$indexHard = ($54b47fc030b7b21e$var$indexHard + 1) % $54b47fc030b7b21e$var$roomsHard.length;
    $54b47fc030b7b21e$var$updateCarouselHard();
    $54b47fc030b7b21e$var$cameraSound.currentTime = 0;
    $54b47fc030b7b21e$var$cameraSound.volume = $54b47fc030b7b21e$var$getVolume("camera-sound");
    $54b47fc030b7b21e$var$cameraSound.play();
});
$54b47fc030b7b21e$var$btnLeftHard.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$indexHard = ($54b47fc030b7b21e$var$indexHard - 1 + $54b47fc030b7b21e$var$roomsHard.length) % $54b47fc030b7b21e$var$roomsHard.length;
    $54b47fc030b7b21e$var$updateCarouselHard();
    $54b47fc030b7b21e$var$cameraSound.currentTime = 0;
    $54b47fc030b7b21e$var$cameraSound.volume = $54b47fc030b7b21e$var$getVolume("camera-sound");
    $54b47fc030b7b21e$var$cameraSound.play();
});
/* =========================================================
   AUDIO — HOVER & CLICK BOUTONS
========================================================= */ const $54b47fc030b7b21e$var$hoverSound = document.getElementById("hover-sound");
document.querySelectorAll("button:not([disabled]):not(.arrows)").forEach((button)=>{
    let hasPlayed = false;
    button.addEventListener("mouseenter", ()=>{
        if (hasPlayed) return;
        $54b47fc030b7b21e$var$hoverSound.currentTime = 0;
        $54b47fc030b7b21e$var$hoverSound.volume = $54b47fc030b7b21e$var$getVolume("hover-sound");
        $54b47fc030b7b21e$var$hoverSound.play();
        hasPlayed = true;
    });
    button.addEventListener("mouseleave", ()=>{
        hasPlayed = false;
    });
    button.addEventListener("click", ()=>{
        const clickingSound = document.getElementById("clicking-sound");
        clickingSound.currentTime = 0;
        clickingSound.volume = $54b47fc030b7b21e$var$getVolume("clicking-sound");
        clickingSound.play();
    });
});
/* =========================================================
   OEIL — SUIT LA SOURIS
========================================================= */ const $54b47fc030b7b21e$var$eyeInside = document.querySelector(".insdie");
const $54b47fc030b7b21e$var$eyeOutside = document.querySelector(".outside");
const $54b47fc030b7b21e$var$videoAnimation = document.querySelector(".image-animation");
let $54b47fc030b7b21e$var$eyeIdleTimeout = null;
document.addEventListener("mousemove", (e)=>{
    if (!$54b47fc030b7b21e$var$eyeInside || !$54b47fc030b7b21e$var$eyeOutside) return;
    $54b47fc030b7b21e$var$eyeInside.style.opacity = "1";
    if ($54b47fc030b7b21e$var$videoAnimation) $54b47fc030b7b21e$var$videoAnimation.style.opacity = "0";
    const rect = $54b47fc030b7b21e$var$eyeOutside.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const dx = e.clientX - centerX;
    const dy = e.clientY - centerY;
    const angle = Math.atan2(dy, dx);
    const maxDist = rect.width * 0.1;
    $54b47fc030b7b21e$var$eyeInside.style.transform = `translate(calc(-50% + ${Math.cos(angle) * maxDist}px), calc(-50% + ${Math.sin(angle) * maxDist}px))`;
    clearTimeout($54b47fc030b7b21e$var$eyeIdleTimeout);
    $54b47fc030b7b21e$var$eyeIdleTimeout = setTimeout(()=>{
        $54b47fc030b7b21e$var$eyeInside.style.opacity = "0";
        if ($54b47fc030b7b21e$var$videoAnimation) $54b47fc030b7b21e$var$videoAnimation.style.opacity = "1";
    }, 1000);
});
/* =========================================================
   POP UP INFO
========================================================= */ const $54b47fc030b7b21e$var$informationPop = document.getElementById("information-pop");
const $54b47fc030b7b21e$var$info = document.getElementById("info");
const $54b47fc030b7b21e$var$okButton = document.getElementById("ok-button");
$54b47fc030b7b21e$var$informationPop.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$info.style.display = "flex";
});
$54b47fc030b7b21e$var$okButton.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$info.style.display = "none";
});
$54b47fc030b7b21e$var$info.addEventListener("click", (e)=>{
    if (e.target === $54b47fc030b7b21e$var$info) $54b47fc030b7b21e$var$info.style.display = "none";
});
/* =========================================================
   SÉCURITÉ — CLIC DROIT DÉSACTIVÉ
========================================================= */ document.addEventListener("contextmenu", (e)=>e.preventDefault());
document.addEventListener("mousedown", (e)=>{
    if (e.button === 2) e.preventDefault();
});
document.addEventListener("mouseup", (e)=>{
    if (e.button === 2) e.preventDefault();
});
/* =========================================================
   CYCLE DE VIE PAGE — STOP SONS
========================================================= */ window.addEventListener("pagehide", $54b47fc030b7b21e$var$stopEverything);
window.addEventListener("beforeunload", $54b47fc030b7b21e$var$stopEverything);
document.addEventListener("visibilitychange", ()=>{
    if (document.hidden) {
        document.querySelectorAll("audio").forEach((audio)=>audio.pause());
        return;
    }
    if ($54b47fc030b7b21e$var$carousel.style.display !== "none" && $54b47fc030b7b21e$var$pauseMenu.style.display === "none") document.getElementById("ambiance-music").play().catch(()=>{});
    if ($54b47fc030b7b21e$var$firstScreen.style.display !== "none") document.getElementById("first-screen-music").play().catch(()=>{});
    if ($54b47fc030b7b21e$var$gameOverScreen.style.display !== "none") {
        document.getElementById("win-sound").play().catch(()=>{});
        document.getElementById("alarm-sound").play().catch(()=>{});
        document.getElementById("dead-sound").play().catch(()=>{});
    }
});


//# sourceMappingURL=index.fb63afdb.js.map
